import * as Add from "./Add.svg.js";
import * as ArrowDown from "./ArrowDown.svg.js";
import * as ArrowLeft from "./ArrowLeft.svg.js";
import * as ArrowRight from "./ArrowRight.svg.js";
import * as ArrowUp from "./ArrowUp.svg.js";
import * as Background from "./Background.svg.js";
import * as CallToAction from "./CallToAction.svg.js";
import * as CaretRight from "./CaretRight.svg.js";
import * as Check from "./Check.svg.js";
import * as ChevronDown from "./ChevronDown.svg.js";
import * as ChevronLeft from "./ChevronLeft.svg.js";
import * as ChevronRight from "./ChevronRight.svg.js";
import * as ChevronUp from "./ChevronUp.svg.js";
import * as Close from "./Close.svg.js";
import * as DarkMode from "./DarkMode.svg.js";
import * as Delete from "./Delete.svg.js";
import * as Discord from "./Discord.svg.js";
import * as Duplicate from "./Duplicate.svg.js";
import * as Edit from "./Edit.svg.js";
import * as EditorBold from "./EditorBold.svg.js";
import * as EditorCode from "./EditorCode.svg.js";
import * as EditorHighlight from "./EditorHighlight.svg.js";
import * as EditorItalic from "./EditorItalic.svg.js";
import * as EditorLink from "./EditorLink.svg.js";
import * as EditorStrike from "./EditorStrike.svg.js";
import * as EditorSubscript from "./EditorSubscript.svg.js";
import * as EditorSuperscript from "./EditorSuperscript.svg.js";
import * as EditorUnderline from "./EditorUnderline.svg.js";
import * as Ellipses from "./Ellipses.svg.js";
import * as Error from "./Error.svg.js";
import * as ExternalLink from "./ExternalLink.svg.js";
import * as Folder from "./Folder.svg.js";
import * as GitHub from "./GitHub.svg.js";
import * as Google from "./Google.svg.js";
import * as Hide from "./Hide.svg.js";
import * as Key from "./Key.svg.js";
import * as Leave from "./Leave.svg.js";
import * as LightDarkModeToggle from "./LightDarkModeToggle.svg.js";
import * as LightMode from "./LightMode.svg.js";
import * as Link from "./Link.svg.js";
import * as Lock from "./Lock.svg.js";
import * as Logo from "./Logo.svg.js";
import * as LogoAPI from "./LogoAPI.svg.js";
import * as LogoClient from "./LogoClient.svg.js";
import * as LogoMarket from "./LogoMarket.svg.js";
import * as LogoSwagger from "./LogoSwagger.svg.js";
import * as Magic from "./Magic.svg.js";
import * as Menu from "./Menu.svg.js";
import * as Page from "./Page.svg.js";
import * as Payment from "./Payment.svg.js";
import * as Refresh from "./Refresh.svg.js";
import * as Search from "./Search.svg.js";
import * as Show from "./Show.svg.js";
import * as Sigma from "./Sigma.svg.js";
import * as Sparkles from "./Sparkles.svg.js";
import * as Star from "./Star.svg.js";
import * as StarSolid from "./StarSolid.svg.js";
import * as TableColAdd from "./TableColAdd.svg.js";
import * as TableColRemove from "./TableColRemove.svg.js";
import * as TableDelete from "./TableDelete.svg.js";
import * as TableHeader from "./TableHeader.svg.js";
import * as TableRowAdd from "./TableRowAdd.svg.js";
import * as TableRowRemove from "./TableRowRemove.svg.js";
import * as ThumbsDown from "./ThumbsDown.svg.js";
import * as ThumbsUp from "./ThumbsUp.svg.js";
import * as Trash from "./Trash.svg.js";
import * as Unlock from "./Unlock.svg.js";
import * as Upload from "./Upload.svg.js";
import * as User from "./User.svg.js";
const icons = /* @__PURE__ */ Object.assign({
  "./Add.svg": Add,
  "./ArrowDown.svg": ArrowDown,
  "./ArrowLeft.svg": ArrowLeft,
  "./ArrowRight.svg": ArrowRight,
  "./ArrowUp.svg": ArrowUp,
  "./Background.svg": Background,
  "./CallToAction.svg": CallToAction,
  "./CaretRight.svg": CaretRight,
  "./Check.svg": Check,
  "./ChevronDown.svg": ChevronDown,
  "./ChevronLeft.svg": ChevronLeft,
  "./ChevronRight.svg": ChevronRight,
  "./ChevronUp.svg": ChevronUp,
  "./Close.svg": Close,
  "./DarkMode.svg": DarkMode,
  "./Delete.svg": Delete,
  "./Discord.svg": Discord,
  "./Duplicate.svg": Duplicate,
  "./Edit.svg": Edit,
  "./EditorBold.svg": EditorBold,
  "./EditorCode.svg": EditorCode,
  "./EditorHighlight.svg": EditorHighlight,
  "./EditorItalic.svg": EditorItalic,
  "./EditorLink.svg": EditorLink,
  "./EditorStrike.svg": EditorStrike,
  "./EditorSubscript.svg": EditorSubscript,
  "./EditorSuperscript.svg": EditorSuperscript,
  "./EditorUnderline.svg": EditorUnderline,
  "./Ellipses.svg": Ellipses,
  "./Error.svg": Error,
  "./ExternalLink.svg": ExternalLink,
  "./Folder.svg": Folder,
  "./GitHub.svg": GitHub,
  "./Google.svg": Google,
  "./Hide.svg": Hide,
  "./Key.svg": Key,
  "./Leave.svg": Leave,
  "./LightDarkModeToggle.svg": LightDarkModeToggle,
  "./LightMode.svg": LightMode,
  "./Link.svg": Link,
  "./Lock.svg": Lock,
  "./Logo.svg": Logo,
  "./LogoAPI.svg": LogoAPI,
  "./LogoClient.svg": LogoClient,
  "./LogoMarket.svg": LogoMarket,
  "./LogoSwagger.svg": LogoSwagger,
  "./Magic.svg": Magic,
  "./Menu.svg": Menu,
  "./Page.svg": Page,
  "./Payment.svg": Payment,
  "./Refresh.svg": Refresh,
  "./Search.svg": Search,
  "./Show.svg": Show,
  "./Sigma.svg": Sigma,
  "./Sparkles.svg": Sparkles,
  "./Star.svg": Star,
  "./StarSolid.svg": StarSolid,
  "./TableColAdd.svg": TableColAdd,
  "./TableColRemove.svg": TableColRemove,
  "./TableDelete.svg": TableDelete,
  "./TableHeader.svg": TableHeader,
  "./TableRowAdd.svg": TableRowAdd,
  "./TableRowRemove.svg": TableRowRemove,
  "./ThumbsDown.svg": ThumbsDown,
  "./ThumbsUp.svg": ThumbsUp,
  "./Trash.svg": Trash,
  "./Unlock.svg": Unlock,
  "./Upload.svg": Upload,
  "./User.svg": User
});
const getIcon = (name) => {
  const filename = `./${name}.svg`;
  if (icons[filename] === void 0) {
    console.warn(`Could not find icon: ${name}`);
    return "";
  }
  return icons[filename];
};
export {
  getIcon
};
//# sourceMappingURL=index.js.map
